import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import ResizeAware from 'react-resize-aware';
import { IMAGES, calculateAsterisk } from '../../util/QuickReportsUtils';

// use this reference http://adazzle.github.io/react-data-grid/examples.html#/tree-view

export default class WebsiteVisitationTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      websiteVisitationTableWidth: null,
      rows: this.createRows(),
      expanded: {},
      columns: [
        {
          key: 'webType',
          name: 'Website',
          resizable: true,
          width: 70,
        },
        {
          key: 'websiteName',
          name: '',
          resizable: true,
        },
        {
          key: 'index',
          name: 'Index',
          resizable: true,
          width: 100,
        },
        {
          key: 'percentage',
          name: 'Percentage',
          resizable: true,
          width: 100,
        },
      ],
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data) {
      this.setState({
        rows: this.createRows(),
        expanded: {},
      });
    }
  }
  onCellExpand = args => {
    const rows = this.state.rows.slice(0);
    const rowKey = args.rowData.websiteName;
    const rowIndex = rows.indexOf(args.rowData);
    const subRows = args.expandArgs.children;
    const expanded = Object.assign({}, this.state.expanded);
    if (expanded && !expanded[rowKey]) {
      expanded[rowKey] = true;
      this.updateSubRowDetails(subRows, args.rowData.treeDepth);
      rows.splice(rowIndex + 1, 0, ...subRows);
    } else if (expanded[rowKey]) {
      expanded[rowKey] = false;
      rows.splice(rowIndex + 1, subRows.length);
    }
    this.setState({ expanded, rows });
  };

  getSubRowDetails = rowItem => {
    const isExpanded = this.state.expanded[rowItem.websiteName]
      ? this.state.expanded[rowItem.websiteName]
      : false;
    return {
      group: rowItem.children && rowItem.children.length > 0,
      expanded: isExpanded,
      children: rowItem.children,
      field: 'webType',
      treeDepth: rowItem.treeDepth || 0,
      siblingIndex: rowItem.siblingIndex,
      numberSiblings: rowItem.numberSiblings,
    };
  };

  createRows = () =>
    this.props.data.map(({ label, value }) => {
      const astrVal = calculateAsterisk(value.sample);
      this.props.updateAsteriskStatus(astrVal);
      return {
        websiteName: label,
        index: astrVal + value.index,
        webType: (
          <img className="folder-icon" src={IMAGES.ICON_Folder2} alt="folder" />
        ),
        percentage: astrVal + value.pct,
        children: this.props.childData[`${this.props.type} - ${label}`]
          ? this.props.childData[`${this.props.type} - ${label}`].map(item => ({
            websiteName: item.label,
            index: calculateAsterisk(item.value.sample) + item.value.index,
            webType: (
              <img
                className="globe-icon"
                src={IMAGES.ICON_Folder}
                alt="globe"
              />
            ),
            percentage: calculateAsterisk(item.value.sample) + item.value.pct,
          }))
          : [],
      };
    });

  updateSubRowDetails = (subRows, parentTreeDepth) => {
    const treeDepth = parentTreeDepth || 0;
    subRows.forEach((sr, i) => {
      sr.treeDepth = treeDepth + 1;
      sr.siblingIndex = i;
      sr.numberSiblings = subRows.length;
    });
  };

  rowGetter = i => this.state.rows[i];

  handleWebsiteVisitationTableResize = dimensions => {
    this.setState({ websiteVisitationTableWidth: dimensions.width });
  };

  render() {
    return (
      <div className="website-visitation-table">
        <ResizeAware
          style={{ position: 'relative', width: '100%' }}
          onlyEvent
          onResize={this.handleWebsiteVisitationTableResize}
        >
          <ReactDataGrid
            enableCellSelect
            columns={this.state.columns}
            rowGetter={this.rowGetter}
            rowsCount={this.state.rows.length}
            getSubRowDetails={this.getSubRowDetails}
            minHeight={300}
            minWidth={this.state.websiteVisitationTableWidth}
            headerRowHeight={30}
            rowHeight={34}
            onCellExpand={this.onCellExpand}
          />
        </ResizeAware>
      </div>
    );
  }
}

WebsiteVisitationTable.propTypes = {
  // handletitle: PropTypes.func,
  //   showSingleAsterisk: PropTypes.string,
  //   showDoubleAsterisk: PropTypes.func,
};
